import { useContext } from "react";
import { ButtonDS, GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../../context/i18n.context";
import { BeneficiaryI } from "../../../../../../api/request/Lead/Interfaces/BeneficiaryInterface";
import { BeneficiaryDataI } from "../../../../../../api/request/Beneficiaries/Interfaces/BeneficiariesInterfaces";
import numberFormat from "../../../../../../utils/Utils";
import { cardStyle, sectionTitleStyle } from "../cardStyles";

interface BeneficiariesCardProps {
  beneficiaries?: BeneficiaryI[];
  resumeBeneficiaryIT?: BeneficiaryDataI[];
  navigateToRoute: (route: string) => void;
}

const BeneficiariesCard = ({
  beneficiaries,
  resumeBeneficiaryIT,
  navigateToRoute,
}: BeneficiariesCardProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  const hasCustomBeneficiaries =
    (beneficiaries && beneficiaries.length > 0) ||
    (resumeBeneficiaryIT && resumeBeneficiaryIT.length > 0);

  return (
    <div style={cardStyle}>
      <div style={sectionTitleStyle}>
        <GlobalIcon iconName="SimpleUserIcon" size="XS" color="#4f46e5" />
        <h2 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: 0 }}>
          {translate("newDashboard.policyPage.beneficiaries")}
        </h2>
      </div>

      {hasCustomBeneficiaries ? (
        <>
          <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16 }}>
            {beneficiaries?.map((b, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "12px 16px",
                  backgroundColor: "#f9fafb",
                  borderRadius: 8,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      backgroundColor: "#eef2ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <GlobalIcon iconName="SimpleUserIcon" size="XS" color="#4f46e5" />
                  </div>
                  <span style={{ fontSize: 15, fontWeight: 500, color: "#111827" }}>
                    {b.Nombre}
                  </span>
                </div>
                {b.Capital > 0 && (
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#4f46e5",
                      backgroundColor: "#eef2ff",
                      padding: "4px 10px",
                      borderRadius: 6,
                    }}
                  >
                    {numberFormat(b.Capital, "capital")}
                  </span>
                )}
              </div>
            ))}
            {resumeBeneficiaryIT?.map((b, idx) => (
              <div
                key={`it-${idx}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "12px 16px",
                  backgroundColor: "#f9fafb",
                  borderRadius: 8,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      backgroundColor: "#eef2ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <GlobalIcon iconName="SimpleUserIcon" size="XS" color="#4f46e5" />
                  </div>
                  <span style={{ fontSize: 15, fontWeight: 500, color: "#111827" }}>
                    {b.fullName}
                  </span>
                </div>
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#4f46e5",
                    backgroundColor: "#eef2ff",
                    padding: "4px 10px",
                    borderRadius: 6,
                  }}
                >
                  {b.percentage}%
                </span>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <ButtonDS
              label={translate("newDashboard.policyPage.beneficiaries.edit")}
              buttonType="secondary"
              size="32"
              disabled
            />
            <span
              style={{
                backgroundColor: "#fef3c7",
                color: "#92400e",
                fontSize: 10,
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: 20,
                lineHeight: 1.4,
                whiteSpace: "nowrap",
              }}
            >
              {translate("newDashboard.redesign.comingSoon")}
            </span>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 12,
              padding: 16,
              backgroundColor: "#fffbeb",
              borderRadius: 8,
              border: "1px solid #fef3c7",
              marginBottom: 16,
            }}
          >
            <GlobalIcon iconName="InfoIcon" size="XS" color="#d97706" />
            <div>
              <p style={{ fontSize: 15, fontWeight: 600, color: "#92400e", margin: 0 }}>
                {translate("newDashboard.policyPage.beneficiaries.default")}
              </p>
              <p style={{ fontSize: 13, color: "#a16207", margin: "4px 0 0" }}>
                {translate("newDashboard.policyPage.beneficiaries.defaultExplain")}
              </p>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <ButtonDS
              label={translate("newDashboard.policyPage.beneficiaries.designate")}
              buttonType="primary"
              size="40"
              onClick={() => navigateToRoute("beneficiaries")}
              disabled
            />
            <span
              style={{
                backgroundColor: "#fef3c7",
                color: "#92400e",
                fontSize: 10,
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: 20,
                lineHeight: 1.4,
                whiteSpace: "nowrap",
              }}
            >
              {translate("newDashboard.redesign.comingSoon")}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default BeneficiariesCard;
